import React, { Component, ReactNode } from 'react';
import { AuthenticatedUser } from '~/Api/Authentication';
import Subscription from '~/Api/Authentication/Subscription';
import ActivityIndicator from '~/UI/ActivityIndicator';
import Breadcrumbs from '~/UI/Breadcrumbs/Breadcrumbs';
import BreadcrumbsItem from '~/UI/Breadcrumbs/BreadcrumbsItem';
import Button, { Link } from '~/UI/Button';
import PrimaryButtonStyles from '~/UI/Button/primary.less';
import SecondaryButtonStyles from '~/UI/Button/secondary.less';
import Heading from '~/UI/Heading';

import styles from './styles.less';

interface Props {
	user: AuthenticatedUser | null;
	subscription: Subscription | null;
	isFetching: boolean;
	onFetch(): void;
	onResetPassword(): Promise<void>;
	onLogout(): void;
}

export default class UserProfilePage extends Component<Props> {
	static defaultProps = {
		user: null,
	};

	componentDidMount() {
		this.props.onFetch();
	}

	renderUser(user: AuthenticatedUser): ReactNode {
		return (
			<div className={styles.profileSection}>
				<Heading>User profile</Heading>
				{user.name !== null ? (
					<div className={styles.profileItem}>
						<div className={styles.profilItemLabel}>Name:</div>
						<div className={styles.profileItemValue}>{user.name}</div>
					</div>
				) : null}
				<div className={styles.profileItem}>
					<div className={styles.profilItemLabel}>E-mail:</div>
					<div className={styles.profileItemValue}>{user.email}</div>
				</div>
				<div className={styles.profileItem}>
					<div className={styles.profilItemLabel}>Company:</div>
					<div className={styles.profileItemValue}>{user.customer.name}</div>
				</div>

				<Button onClick={this.requestPasswordChangeClicked}>Request password change</Button>

				<div className={styles.logoutButtonContainer}>
					<Button styles={SecondaryButtonStyles} onClick={this.props.onLogout}>
						Logout
					</Button>
				</div>
			</div>
		);
	}

	renderRoMaxPrice() {
		return (
			<div className={styles.profileSection}>
				<Heading level={1}>My modules</Heading>
				<Link styles={PrimaryButtonStyles} to='/profile/settings/ro-max-price'>
					Romania Max Price export settings
				</Link>
			</div>
		);
	}

	requestPasswordChangeClicked = () => {
		this.props.onResetPassword();
	};

	render() {
		const { user, subscription, isFetching } = this.props;

		return (
			<section className={styles.section}>
				<Breadcrumbs>
					<BreadcrumbsItem to='/'>Search</BreadcrumbsItem>
					<BreadcrumbsItem>User profile</BreadcrumbsItem>
				</Breadcrumbs>

				<div className={styles.in}>
					{isFetching ? <ActivityIndicator /> : user ? this.renderUser(user) : null}
					{subscription?.systemModules.has('ro-max-price') ? this.renderRoMaxPrice() : null}
				</div>
			</section>
		);
	}
}
